import IntegrationsDashboard from './IntegrationsDashboard'

export default IntegrationsDashboard
